import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { AppMenuitemComponent } from './app.menuitem.component';
import { Menu, PrivilegeResponse } from '../_models/menuModel';
import { MenuPrivilegeService } from '../_services/menuPrivilege.service';
import { StorageService } from '../_services/storage.service';
import { Router } from '@angular/router';


import { PermissionService } from '../_services/permission.service';
import { MenuService } from './app.menu.service';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, AppMenuitemComponent],
  standalone: true,
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];
  selectedItem: any | null = null;

  private menuPrivilegeService = inject(MenuPrivilegeService);
  private storageService = inject(StorageService);
  private router = inject(Router);
  private permissionService = inject(PermissionService);
  private menuService = inject(MenuService);

  ngOnInit() {
    this.defaultMenu();
    const user = this.storageService.getUser();
    const roleCode = user?.roleCode;
    if (roleCode) {
      this.loadPrivileges(roleCode);
    } else {
      console.warn('Role not available');
    }
  }

  defaultMenu() {
    this.model = [
      {
        label: 'หน้าหลัก',
        icon: 'pi pi-th-large',
        items: [
          // {
          //   label: 'แดชบอร์ด',
          //   icon: 'pi pi-fw pi-home',
          //   routerLink: ['/home'],
          // },
        ],
      },
      { separator: true },
    ];
  }

  loadPrivileges(roleCode: string) {

    this.menuPrivilegeService.getMenuPrivilegeByRoleCode(roleCode).subscribe(
      (response: PrivilegeResponse) => {
        const dynamicMenus = this.transformPrivilegesToMenu(response.menus);

        this.model = [...this.model, ...dynamicMenus];

        const allLinks = dynamicMenus.flatMap((menu) =>
          (menu.items ?? []).map((item: any) => item.routerLink[0])
        );
        this.menuService.registerMenuLinks(allLinks);

        const justWhenLogin = localStorage.getItem('redirectAfterLogin') === 'true';
        if (justWhenLogin) {
          localStorage.removeItem('redirectAfterLogin');
          this.navigateToFirstMenu(); //here to remove later 
        }

      },
      (error) => {
        console.error('Error loading privileges:', error);
      }
    );
  }

  transformPrivilegesToMenu(menus: Menu[]): any[] {
    return menus
      .map((menu) => {
        // กรองเฉพาะ privilege ที่ isRead == true
        const readableItems = menu.privilegeDetails
          .filter((detail) => detail.isRead)
          .map((detail) => ({
            label: detail.menuName,
            icon: detail.menuIcon,
            routerLink: [detail.menuUrl],
            command: () => this.handleMenuClick(
              detail.menuUrl,
              detail.isRead,
              detail.isEdit,
              detail.isApprove,
              detail.isDownload
            ),
          }));

        // ถ้าไม่มีรายการใดอ่านได้เลย ไม่ต้องแสดงเมนูนี้
        if (readableItems.length === 0) {
          return null;
        }

        return {
          label: menu.menuName,
          icon: 'pi pi-th-large',
          items: readableItems,
        };
      })
      .filter((menu) => menu !== null); // ตัดเมนูที่ไม่มีสิทธิ์ออก
  }



  handleMenuClick(menuUrl: string, isRead: boolean, isEdit: boolean, isApprove: boolean, isDownload: boolean) {
    this.permissionService.setPermission(menuUrl, isRead, isEdit, isApprove, isDownload);
    this.router.navigate([menuUrl]);
  }

  navigateToFirstMenu() { // Navigate to the first menu item na ja
    for (const menu of this.model) {
      if (menu.items && menu.items.length > 0) {
        const firstItem = menu.items[0];
        if (firstItem.routerLink) {
          this.handleMenuClick(firstItem.routerLink[0], firstItem.isRead, firstItem.isEdit, firstItem.isApprove, firstItem.isDownload);
        }
        break;
      }
    }
  }

  selectItem(item: any) {

    if (item.routerLink) {
      this.handleMenuClick(item.routerLink[0], item.isRead, item.isEdit, item.isApprove, item.isDownload);
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItem === item;
  }
}
